import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'aerovalePrefijo'
})
export class AerovalePrefijoPipe implements PipeTransform {

  transform(value: number | string): string {
    if (value !== undefined && value !== null) {
      return value.toString().padStart(3, '0');
    } else {
      return "";
    }
  }

}
